import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import OurApproach from '../media/proven_approach.webp'

export default function ProvenApproach() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });

  // Variantes del contenedor (orquestador)
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, // tiempo entre hijos
        delayChildren: 0.3, // retardo inicial
      },
    },
  };
  // console.log(OurApproach);

  // Variantes de cada tarjeta
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const items = [
    {
      title: "Dedicated Engineering Team",
      text: "Expert in latest design techniques and regulations for high-quality, efficient plans.",
      icon: "fa-hand-fist",
    },
    {
      title: "Streamlined Project Management",
      text: "Experienced professionals ensuring seamless coordination and timely execution.",
      icon: "",
    },
    {
      title: "Robust Permitting Processes",
      text: "Strong relationships with local authorities to navigate permitting effectively.",
      icon: "",
    },
    {
      title: "Proactive Communication",
      text: "Keeping clients informed at every stage, addressing concerns promptly.",
      icon: "",
    },
    {
      title: "Continuous Process Improvement",
      text: "Constantly refining methods to stay at the forefront of the industry.",
      icon: "",
    },
    {
      title: "Foto de Ivan Bandur en Unsplash.com",
      text: "",
      img: OurApproach,
    },
  ];

  return (
    <section
      ref={ref}
      className="p-6 md:px-10 pb-10  bg-primario text-primario font-secundaria"
    >
      <h2 className="text-3xl sm:text-4xl lg:text-7xl font-bold text-center mb-12 font-primaria text-secundario">
        Our Proven Approach
      </h2>
      <div className="max-w-7xl mx-auto">
        <motion.div
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-10"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "show" : "hidden"}
        >
          {items.map((item, index) => (
            <motion.div
              key={index}
              className=" bg-white shadow-md rounded-lg h-[30vh] md:h-[40vh] flex
              flex-col justify-center items-center text-center overflow-hidden"
              variants={cardVariants}
            >
              {item.img ?
                <div className="w-full h-full">
                  <img src={item.img} alt={item.title} className="object-cover w-full h-full"/>
                </div>
              : 
                <div className="p-2 md:p-6">
                  <h3 className="text-2xl md:text-4xl mb-3 font-primaria text-center font-bold texsec">
                    {item.title}
                  </h3>
                  <p className="md:text-2xl">{item.text}</p>
                </div>
              }
              {/* <i class={`fa-solid ${item.icon} fa-10x`}></i> */}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
